import { useChangeOwners } from 'scenes/Campaigns/GGCampaigns/data/mutations';

import { OWNER_ID, PERIOD_START_DATE, CAMPAIGN_IDS } from '../constants';
import { ChangeOwnerForm } from './ChangeOwnerForm';

const ChangeOwner = ({
  initialValues,
  onSubmit,
  onClose,
  open,
  onExited,
  minDate,
  count,
  filter,
}) => {
  const [changeOwners, { isLoading }] = useChangeOwners();

  const handleSubmit = async (values) => {
    await changeOwners({
      [OWNER_ID]: values[OWNER_ID],
      [PERIOD_START_DATE]: values[PERIOD_START_DATE],
      [CAMPAIGN_IDS]: values[CAMPAIGN_IDS],
      filter,
    });
    onSubmit();
  };

  return (
    <ChangeOwnerForm
      count={count}
      initialValues={initialValues}
      loading={isLoading}
      onClose={onClose}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      minDate={minDate}
    />
  );
};

export default ChangeOwner;
